import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-funnel-header',
  standalone: true,
  imports: [],
  templateUrl: './funnel-header.component.html',
  styleUrls: ['./funnel-header.component.scss']
})
export class FunnelHeaderComponent {
  @Input() currentStep = 1;
}
